export const PROJECTS_ROUTE = "/dashboard/project";
export const DASHBOARD = "/dashboard";
export const AUTH = "/login"

export function routeTo(path, props) {
  props.history.push(path)
}

export function routeToLogin() {
  const { origin } = window.location;
  window.location = `${origin}/login`;
}